import { ILayoutProps } from 'src/types/main'

export default function AuthLayout({ children, variant }: ILayoutProps) {
  return <div className={`auth -${variant}`}> {children} </div>
}
